import styled from 'styled-components/macro'
import { TextInput } from '../TextInput'
import { inputBaseStyle } from 'style/inputBaseStyle'

export const Adornment = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 0.4rem;
  visibility: visible;
  flex-shrink: 0;

  > button {
    height: 100%;
    padding-bottom: 0;
    padding-top: 0;
  }
`

export const StyledTextInput = styled(TextInput)`
  background: transparent;
  border: none;
  flex: 1;
  height: inherit;
  padding: 0;

  ::placeholder {
    padding-left: 0;
    padding-right: 0;
  }
`

export const Wrap = styled.div<{
  disabled?: boolean
  error?: boolean
}>`
  ${inputBaseStyle};
  padding: 0;

  /** sc-block is req bc styled-components interpolation creates warning in stylelint  */
  ${
    /* sc-block */ ({ disabled }) =>
      disabled &&
      `
      background-color: var(--gray-100);
      border-color: var(--border-subtle);
      color: var(--gray-400);
      user-select: none;
  `
  }
  :focus-within {
    border-color: var(--focus-ring);
  }
`

export const AdornmentWrap = styled.div<{
  hasStartAdornment?: boolean
  hasEndAdornment?: boolean
}>`
  display: flex;
  flex-flow: row nowrap;
  max-width: 100%;
  height: 3.25rem;
  overflow: hidden;
  padding: 0;
  padding-left: ${({ hasStartAdornment }) =>
    !hasStartAdornment ? '1rem' : '0rem'};
  padding-right: ${({ hasEndAdornment }) =>
    !hasEndAdornment ? '1rem' : '0rem'};
`

export const IconWrap = styled.div`
  display: inline-flex;
  height: inherit;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  fill: var(--gray-400);
  flex-shrink: 0;

  /** sc-selector is req bc styled-components interpolation creates warning in stylelint  */
  ${/* sc-selector */ Wrap}:focus-within & {
    fill: var(--text-strong);
  }
`
